import {Component} from '@angular/core';

/* Body only -- HelpDialogComponent supplies the dialog chrome and the Okay
   button, so every page's help looks the same. */
@Component({
    selector: 'app-business-rules-help',
    templateUrl: './business-rules-help.component.html'
})
export class BusinessRulesHelpComponent {
    /* The Volume Trigger section only makes sense where those fields are turned
       on, so it follows the same flag the grid columns use. */
    volumeTriggerVisible(): boolean {
        return !!parseInt(localStorage.getItem('volumeTriggerVisibility'), 10);
    }

    /* Min Alloc / Max Alloc are likewise gated, and are cached separately by the
       business rules screen. */
    allocRulesVisible(): boolean {
        return !!parseInt(localStorage.getItem('minAllocVisibility'), 10)
            || !!parseInt(localStorage.getItem('maxAllocVisibility'), 10);
    }
}
